<template>
  <div>
    <div class="flex-container">
      <div class="steps">
        <div class="title">立项评审进度情况</div>
        <el-steps align-center :active="stepsList.length">
          <el-step
            :title="`${item.name}-${item.status}`"
            :description="item.time"
            v-for="(item, index) in stepsList"
            :key="index"
            :status="
              item.isgreen === '0'
                ? 'error'
                : item.isgreen === '1'
                ? 'success'
                : 'wait '
            "
          ></el-step>
        </el-steps>
      </div>
      <div class="table">
        <div class="title">管理组检查情况</div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            @click="handleChangeAddDialog"
            :disabled="!isAdd"
            >意见反馈</el-button
          >
        </div>
        <el-table
          :max-height="height"
          :data="glzjcList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <!-- v-if="scope.row.permissions.ischecklist" -->
          <el-table-column
            label="操作"
            align="left"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="lxsqFormDialog = true"
                size="mini"
                v-if="scope.row.permissions.isapplylist"
              >
                立项申请单
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.permissions.isedit"
                @click="handleChangeEditDialog(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                @click="delCheckItem(scope.row.feedbackId)"
                v-if="scope.row.permissions.isdel"
                size="mini"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="反馈人"
            align="left"
            prop="ygbh"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="反馈时间"
            align="left"
            prop="feedbackTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="意见反馈"
            align="left"
            prop="content"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="状态"
            align="left"
            prop="statusName"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理人"
            align="left"
            prop="solveBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理时间"
            align="left"
            prop="solveTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查人"
            align="left"
            prop="checkBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查时间"
            align="left"
            prop="checkTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <div class="table_count">共{{ glzjcList.length }}条记录</div>
      </div>
      <div class="result">
        <div class="title">评委评审结果和意见反馈</div>
        <div>
          <div>
            <el-tabs v-model="resultActive">
              <el-tab-pane
                :label="item.judgeser"
                :name="index + ''"
                v-for="(item, index) in resultList"
                :key="index"
              >
                <div class="result_info">
                  <div>评审结果: {{ item.resultData }}</div>
                  <div>评审形式：{{ item.typeData }}</div>
                </div>
                <div
                  class="result_detail"
                  v-for="(item2, index2) in item.advices"
                  :key="index2"
                >
                  <div class="result_content">
                    <div class="label">{{ item2.scoreType }}</div>
                    <div class="text">
                      <div v-html="item2.reference"></div>
                      <div v-html="item2.scoreTitle"></div>
                      <div class="advice" v-html="item2.adviceValue"></div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加意见反馈"
      :visible.sync="addAdviceDialog"
      append-to-body
      width="900px"
      v-if="addAdviceDialog"
      :closeOnClickModal="false"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 12 }"
        maxlength="3000"
        show-word-limit
        placeholder="请输入意见反馈"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAdviceDialog = false">取 消</el-button>
        <el-button type="primary" @click="addAdviceDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑意见反馈"
      :visible.sync="editAdviceDialog"
      width="900px"
      append-to-body
      v-if="editAdviceDialog"
      :closeOnClickModal="false"
    >
      <div style="margin-bottom: 15px">
        <span style="margin-right: 30px">状态：</span>
        <el-radio-group v-model="editform.status">
          <el-radio label="1">待修改 </el-radio>
          <el-radio label="2">修改通过</el-radio>
        </el-radio-group>
      </div>
      <div>
        <div style="margin-bottom: 15px">意见反馈：</div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAdviceDialog = false">取 消</el-button>
        <el-button type="primary" @click="editAdviceDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div v-show="addAdviceDialog">
      <el-dialog
        title="意见反馈"
        :visible.sync="addAdviceDialog"
        append-to-body
        width="900px"
        :closeOnClickModal="false"
      >
        <div style="display: flex" v-if="feedbackId">
          <span style="width: 72px; text-align: right; margin-right: 15px"
            >状态<span style="color: #ff0000">*</span>:</span
          >
          <span>
            <el-radio-group v-model="addAdviceForm.status">
              <el-radio label="1">待修改</el-radio>
              <el-radio label="3">修改通过</el-radio>
            </el-radio-group></span
          >
        </div>
        <div style="line-height: 44px">
          意见反馈<span style="color: #ff0000">*</span> ：
        </div>
        <el-input
          type="textarea"
          v-model="addAdviceForm.content"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="addAdviceDialog = false">取 消</el-button>
          <el-button type="primary" @click="addAdvice">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog
      title="立项申请"
      :visible.sync="lxsqFormDialog"
      width="90%"
      v-if="lxsqFormDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <LxsqForm
        :mxParams="mxParams"
        ref="lxsqForm"
        @getParentForm="getList"
      ></LxsqForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lxsqFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveLxsqForm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import LxsqForm from "../courseLxsqForm/lxsqForm.vue";
import {
  getApprovalReview,
  getReviewJd,
  getListAllFeedback,
  insertFeedback,
  editFeedback,
  deleteInspection,
} from "@/api/course.js";
export default {
  name: "courseLxps",
  props: ["mxParams", "course"],
  computed: {
    ...mapGetters(["course"]),
  },
  components: { LxsqForm },
  data() {
    return {
      height: 500,
      resultActive: "0",
      resultList: [], //评委评审结果和意见反馈
      tableList: [],
      glzjcList: [], //管理组检查表
      addAdviceDialog: false,
      editAdviceDialog: false,
      lxsqFormDialog: false,
      isEdit: false,
      editform: { status: "1" },
      stepsList: [],
      addAdviceForm: {
        status: "1",
        content: null,
      },
      isAdd: true,
      feedbackId: null,
    };
  },

  created() {
    if (
      !this.course.courseFeedbackInfo ||
      this.course.courseFeedbackInfo.length == 0
    ) {
      this.$store.dispatch("course/fetchInspectionAction", {
        courseId: this.mxParams.id,
      });
    }
    getApprovalReview({ courseId: this.mxParams.id }).then((res) => {
      if (res.code == 0) {
        this.resultList = res.data;
      }
    });
    this.getList();
    getReviewJd({ courseId: this.mxParams.id }).then((res) => {
      if (res.code == 0) {
        let temp = [];
        this.stepsList = res.data;
        for (let i of this.stepsList) {
          if (i.name) {
            temp.push(i);
          }
        }
        this.stepsList = temp;
      }
    });
  },
  mounted() {},
  methods: {
    toApplyForm(id) {},
    getList() {
      this.lxsqFormDialog = false;
      this.fetchListAllFeedback();
    },
    // 管理组检查情况
    fetchListAllFeedback() {
      getListAllFeedback({ courseId: this.mxParams.id, step: 2 }).then(
        (res) => {
          if (res.code == 0) {
            this.glzjcList = res.data.courseFeedbackInfo;
            this.isAdd = res.data.isAdd == 1 ? true : false;
          }
        }
      );
    },
    //删除管理组检查情况
    delCheckItem(feedbackId) {
      deleteInspection({ feedbackId }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.fetchListAllFeedback();
          this.fetchgetReviewJd();
        }
      });
    },

    fetchgetReviewJd() {
      getReviewJd({ courseId: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          let temp = [];
          this.stepsList = res.data;
          for (let i of this.stepsList) {
            if (i.name) {
              temp.push(i);
            }
          }
          this.stepsList = temp;
        }
      });
    },
    handleChangeAddDialog() {
      this.addAdviceDialog = true;
      this.addAdviceForm = {
        status: "1",
        content: null,
      };
    },
    handleChangeEditDialog(row) {
      this.addAdviceForm = {
        status: row.status,
        content: row.content,
      };
      this.feedbackId = row.feedbackId;
      this.addAdviceDialog = true;
    },
    addAdvice() {
      if (!this.addAdviceForm.status) {
        this.$message.error("状态不能为空！");
        return;
      }
      if (!this.addAdviceForm.content) {
        this.$message.error("意见反馈不能为空！");
        return;
      }
      if (this.feedbackId) {
        editFeedback({
          step: "2",
          courseId: this.mxParams.id,
          content: this.addAdviceForm.content,
          status: this.addAdviceForm.status,
          feedbackId: this.feedbackId,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.feedbackId = null;
            this.fetchListAllFeedback();
            this.fetchgetReviewJd();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        insertFeedback({
          status: "1",
          step: "2",
          content: this.addAdviceForm.content,
          courseId: this.mxParams.id,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.fetchListAllFeedback();
            this.fetchgetReviewJd();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    saveLxsqForm() {
      this.$refs.lxsqForm.saveForm();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  font-size: 14px;
  .result_info {
    color: #666;
    line-height: 32px;
    padding-left: 15px;
    margin-bottom: 15px;
  }
  .result_detail {
    color: #666;
    line-height: 32px;
    padding-left: 15px;
    margin-bottom: 15px;

    .result_content {
      border: 1px solid #ddd;
      .label {
        line-height: 42px;
        font-size: 16px;
        background-color: #f3f3f3;
        padding-left: 15px;
      }
      .text {
        padding: 15px;
        .advice {
          background: #f3f3f3;
          color: #ff0000;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>